import React from 'react'
import PropTypes from 'prop-types';

import {CLIENT_BASE_URL} from '../../actions'
// import LogoPreto from './LogoPreto.png'

export class SponsorView extends React.Component {

  constructor (props) {
    super(props)
    this.renderSponsorImage = this.renderSponsorImage.bind(this)
    this.onClickExpandSponsor = this.onClickExpandSponsor.bind(this)
    this.getTitle = this.getTitle.bind(this)
  }

  renderSponsorImage (info) {
    return info.map((sp, i) => {
      return (
        <a key={`spn${i}`} href={sp.link} target='_blank'>
          <img src={CLIENT_BASE_URL + sp.thumb} />
        </a>
      )
    })
  }

  getTitle (title) {
    title = title.toUpperCase()
    return title
  }

  renderLeftColumn () {
    const {sponsors, sponsorIds} = this.props

    if (!sponsorIds.length) {
      return null
    }
    const info = sponsors[sponsorIds[0]]
    if (!info.length) {
      return null
    }

    return (
      <div className='hdr-wth-logo'>
        <p>{this.getTitle(info[0].name)}</p>
        {this.renderSponsorImage(info)}
      </div>
    )
  }

  renderPremium (sponsorData) {
    if (!sponsorData.length) {
      return (
        <div></div>
      )
    }

    return (
      <div>
        <p>{this.getTitle(sponsorData[0].name)}</p>
        {this.renderSponsorImage(sponsorData)}
      </div>
    )
  }

  onClickExpandSponsor (e) {
    var el = e.target.parentNode
    el.className = el.classList.contains('expanded') ? 'otherSponser' : 'otherSponser expanded'
  }

/*
  renderOthers () {
    const {sponsors} = this.props
    const defaultSps = sponsors['default']

    if (defaultSps) {
      return Object.keys(defaultSps).map((tag, i) => {
        return (
          <div key={`j${i}`} className='row'>
            <div key={`i${i}`} className='otherSponser'>
              <p>{this.getTitle(tag)}</p>
              <div ref='arrow' className='arrow-up-down' onClick={this.onClickExpandSponsor}></div>
              <div className='icon-block' >
                {this.renderSponsorImage(sponsors['default'][tag])}
              </div>
            </div>
          </div>
        )
      })
    }
  }
*/

  renderOthers () {
    const {sponsors, sponsorIds} = this.props
    const ntags = sponsorIds.length

    let cnt = 2
    let sponsorList = []

    while (cnt < ntags) {
      let tag = sponsorIds[cnt]
      let prevtag = sponsorIds[cnt-1]

      if (!sponsors[prevtag].length) {
        cnt += 1
        continue
      }

      if (!sponsors[tag].length) {
        cnt += 1
        continue
      }

      let prevMinimized = parseInt(sponsors[prevtag][0].minimized, 10)
      let curMinimized = parseInt(sponsors[tag][0].minimized, 10)

      if (prevMinimized === curMinimized && prevMinimized === 0) {
        sponsorList = [...sponsorList, {
          type: 'twocols',
          tags: [sponsors[prevtag], sponsors[tag]]
        }]
        cnt += 2
      } else {
        let type = prevMinimized === 0 ? 'onecol' : 'onecol_minimized'
        sponsorList = [...sponsorList, {
          type: type,
          tags: [sponsors[prevtag]]
        }]
        cnt += 1
      }
    }

    if ((cnt > (ntags-1) && cnt < (ntags+1)) && ntags > 2) {
      // nao foi feito o render da ultima
      let tag = sponsorIds[ntags-1]
      let type = parseInt(sponsors[tag][0].minimized, 10) === 0 ? 'onecol' : 'onecol_minimized'
      sponsorList = [...sponsorList, {
        type: type,
        tags: [sponsors[tag]]
      }]
    }

    return sponsorList.map((splist, i) => {
      if (splist.type === 'twocols') {
        return (
          <div key={`spo${i}`} className='row red-border'>
            <div className='col-md-6 hdr-wth-logo text-center'>
              {this.renderPremium(splist.tags[0])}
            </div>
            <div className='col-md-6 hdr-wth-logo text-center'>
              {this.renderPremium(splist.tags[1])}
            </div>
          </div>
        )
      } else if (splist.type === 'onecol') {
        return (
          <div className='col-md-12 hdr-wth-logo text-center'>
            {this.renderPremium(splist.tags[0])}
          </div>
        )
      } else {
        return (
          <div key={`j${i}`} className='row'>
            <div key={`i${i}`} className='otherSponser'>
              <p>{this.getTitle(splist.tags[0][0].name)}</p>
              <div ref='arrow' className='arrow-up-down' onClick={this.onClickExpandSponsor}></div>
              <div className='icon-block' >
                {this.renderSponsorImage(splist.tags[0])}
              </div>
            </div>
          </div>
        )
      }
    })
  }

  render () {
    const {sponsors} = this.props
    if (Object.keys(sponsors).length === 0) {
      return (
        <div>
        </div>
      )
    }

    return (
      <div id='sponsor-view'>
        <div className='col-lg-12'>
          <div className='col-md-3'>
            {this.renderLeftColumn()}
          </div>

          <div className='col-md-9'>
            {this.renderOthers()}
          </div>
        </div>
        <div id='general-links' className='row text-right'>
          <div className='col-md-12'>
            <p>
              <a href='#'>REGULAMENTO GERAL | </a>
              <a href='#'>TERMOS DE USO | </a>
              <a href='#'>BILHETES | </a>
              <a href='#'>MAPA DO SITE</a>
            </p>
            <p>8 1/2 Festa do Cinema Italiano © 2016 Todos os direitos reservados</p>
          </div>
        </div>
      </div>
    )
  }
}

SponsorView.propTypes = {
  sponsors: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.array
  ]).isRequired,
  sponsorIds: PropTypes.array.isRequired
}



// WEBPACK FOOTER //
// ./src/views/SponsorView/SponsorView.js